(function () {
  document.documentElement.classList.remove('no-js');

  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Measure announcement bar height for sticky offset
    const announcement = header.querySelector('.announcement-bar');
    if (announcement) {
      const updateAnnouncementHeight = () => {
        const height = announcement.offsetHeight;
        document.documentElement.style.setProperty('--announcement-height', `${height}px`);
      };
      updateAnnouncementHeight();
      window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
      window.addEventListener('load', updateAnnouncementHeight, { passive: true });
      if (window.ResizeObserver) {
        new ResizeObserver(updateAnnouncementHeight).observe(announcement);
      }
    } else {
      document.documentElement.style.setProperty('--announcement-height', '0px');
    }
  }

  document.querySelectorAll('[data-mobile-menu-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      menu.hidden = false;
      document.body.classList.add('mobile-nav-open');
      requestAnimationFrame(() => menu.classList.add('is-open'));
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      menu.classList.remove('is-open');
      document.body.classList.remove('mobile-nav-open');
      window.setTimeout(() => {
        if (!menu.classList.contains('is-open')) menu.hidden = true;
      }, 300);
    });
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const moneyFormat = window.Shopify?.money_format || '${{amount}}';
  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  };
  const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  const headerSearch = document.querySelector('[data-header-search]');
  if (headerSearch) {
    const input = headerSearch.querySelector('[data-header-search-input]');
    const results = headerSearch.querySelector('[data-header-search-results]');
    const openButtons = document.querySelectorAll('[data-header-search-open]');
    let searchAbortController = null;
    let searchTimer = null;

    const searchImageUrl = (product) => (
      product.featured_image?.url ||
      product.image ||
      product.featured_image ||
      ''
    );

    const openHeaderSearch = () => {
      if (header) headerSearch.style.setProperty('--header-overlay-top', `${header.getBoundingClientRect().bottom}px`);
      headerSearch.hidden = false;
      document.body.classList.add('header-search-open');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => {
        headerSearch.classList.add('is-open');
        input?.focus();
      });
    };

    const closeHeaderSearch = () => {
      headerSearch.classList.remove('is-open');
      document.body.classList.remove('header-search-open');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      window.setTimeout(() => {
        if (!headerSearch.classList.contains('is-open')) headerSearch.hidden = true;
      }, 260);
    };

    const renderSearchResults = (products, query) => {
      if (!results) return;
      if (!query) {
        results.innerHTML = '<div class="header-search__empty">Start typing to search products, categories, and COA-supported research compounds.</div>';
        return;
      }
      if (!products.length) {
        results.innerHTML = `<div class="header-search__empty">No products found for "${escapeHTML(query)}". Try a shorter search term.</div>`;
        return;
      }
      results.innerHTML = `
        <div class="header-search__grid">
          ${products.map((product) => {
            const image = searchImageUrl(product);
            const price = product.price_min || product.price || product.compare_at_price_min || '';
            return `
              <a class="header-search__item" href="${product.url}">
                <span class="header-search__image">
                  ${image ? `<img src="${image}" alt="${escapeHTML(product.title)}" loading="lazy">` : '<span class="header-search__placeholder">Product</span>'}
                </span>
                <span class="header-search__meta">
                  <span class="header-search__title">${escapeHTML(product.title)}</span>
                  ${price ? `<span class="header-search__price">${escapeHTML(price)}</span>` : '<span class="header-search__price">View details</span>'}
                </span>
              </a>
            `;
          }).join('')}
        </div>
        <div class="header-search__view-all">
          <a href="/search?q=${encodeURIComponent(query)}&type=product">View all results</a>
        </div>
      `;
    };

    const runHeaderSearch = (query) => {
      if (!results) return;
      if (searchAbortController) searchAbortController.abort();
      if (!query) {
        renderSearchResults([], '');
        return;
      }
      searchAbortController = new AbortController();
      results.innerHTML = '<div class="header-search__status">Searching...</div>';
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, {
        headers: { Accept: 'application/json' },
        signal: searchAbortController.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Search failed');
          return response.json();
        })
        .then((data) => renderSearchResults(data.resources?.results?.products || [], query))
        .catch((error) => {
          if (error.name === 'AbortError') return;
          results.innerHTML = `<div class="header-search__empty">Search is temporarily unavailable. <a href="/search?q=${encodeURIComponent(query)}&type=product">Open full search</a>.</div>`;
        });
    };

    openButtons.forEach((button) => button.addEventListener('click', openHeaderSearch));
    headerSearch.querySelectorAll('[data-header-search-close]').forEach((button) => {
      button.addEventListener('click', closeHeaderSearch);
    });
    input?.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      const query = input.value.trim();
      searchTimer = window.setTimeout(() => runHeaderSearch(query), 180);
    });
    headerSearch.addEventListener('click', (event) => {
      if (event.target.closest('.header-search__item')) closeHeaderSearch();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !headerSearch.hidden) closeHeaderSearch();
    });
  }

  const updateHeaderCartBadges = (itemCount) => {
    document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
      const sr = trigger.querySelector('.sr-only');
      if (sr) sr.textContent = `Cart${itemCount > 0 ? ` (${itemCount})` : ''}`;
      let badge = trigger.querySelector('.icon-badge');
      if (itemCount > 0 && !badge) {
        badge = document.createElement('span');
        badge.className = 'icon-badge';
        badge.setAttribute('aria-hidden', 'true');
        trigger.appendChild(badge);
      }
      if (itemCount === 0 && badge) badge.remove();
    });
  };

  const renderCartDrawer = (cart) => {
    if (!cartDrawer) return;
    const body = cartDrawer.querySelector('[data-cart-drawer-body]');
    const count = cartDrawer.querySelector('[data-cart-drawer-count]');
    const subtotal = cartDrawer.querySelector('[data-cart-drawer-subtotal]');
    const checkout = cartDrawer.querySelector('[data-cart-drawer-checkout]');
    if (count) count.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`;
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (checkout && checkout.tagName === 'BUTTON') checkout.disabled = cart.item_count === 0;
    if (checkout && checkout.tagName !== 'BUTTON') checkout.classList.toggle('is-disabled', cart.item_count === 0);
    updateHeaderCartBadges(cart.item_count);
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is currently empty.</p>
          <div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:12px">
            <a class="btn btn-primary" href="/collections/all">Browse catalog</a>
            <button class="btn" type="button" data-cart-drawer-close>Keep shopping</button>
          </div>
        </div>
      `;
      return;
    }

    body.innerHTML = `
      <div class="cart-drawer__items">
        ${cart.items.map((item) => `
          <div class="cart-drawer__item" data-cart-line="${item.key}">
            <a class="cart-drawer__item-image" href="${item.url}">
              ${item.image ? `<img src="${item.image}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : ''}
            </a>
            <div class="cart-drawer__item-main">
              <div class="cart-drawer__item-top">
                <div>
                  <a class="cart-drawer__item-title" href="${item.url}">${escapeHTML(item.product_title)}</a>
                  ${item.variant_title ? `<div class="cart-drawer__item-variant">${escapeHTML(item.variant_title)}</div>` : ''}
                </div>
                <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
              </div>
              <div class="cart-drawer__item-controls">
                <div class="cart-drawer__qty">
                  <button type="button" data-cart-change="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">-</button>
                  <input type="number" min="0" value="${item.quantity}" aria-label="Quantity for ${escapeHTML(item.product_title)}" data-cart-quantity-input data-key="${item.key}">
                  <button type="button" data-cart-change="${item.key}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
                </div>
                <button class="cart-drawer__remove" type="button" data-cart-change="${item.key}" data-quantity="0">Remove</button>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    `;
  };

  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
  const refreshCartDrawer = () => fetchCart().then(renderCartDrawer).catch(() => {});
  const openCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    requestAnimationFrame(() => cartDrawer.classList.add('is-open'));
    document.body.classList.add('cart-drawer-open');
    refreshCartDrawer();
    cartDrawer.querySelector('.cart-drawer__panel')?.focus();
  };
  const closeCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(() => {
      if (!cartDrawer.classList.contains('is-open')) cartDrawer.hidden = true;
    }, 260);
  };
  const changeCartLine = (key, quantity) => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
      .then((response) => response.json())
      .then(renderCartDrawer)
      .catch(() => refreshCartDrawer());
  };

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-cart-drawer-open]');
    if (openTrigger && cartDrawer) {
      event.preventDefault();
      openCartDrawer();
      return;
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (change) {
      event.preventDefault();
      changeCartLine(change.dataset.cartChange, Number(change.dataset.quantity || 0));
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    changeCartLine(input.dataset.key, Math.max(0, Number(input.value || 0)));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cartDrawer && !cartDrawer.hidden) closeCartDrawer();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !cartDrawer) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then((response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => openCartDrawer())
      .catch(() => form.submit())
      .finally(() => {
        if (button) button.disabled = false;
      });
  });

  document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
    const input = selector.querySelector('[data-quantity-input]');
    const minus = selector.querySelector('[data-quantity-minus]');
    const plus = selector.querySelector('[data-quantity-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus?.addEventListener('click', () => {
      input.value = Math.min(99, Number(input.value || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantJson = section.querySelector('[data-product-json]');
    const variants = variantJson ? JSON.parse(variantJson.textContent) : [];
    const form = section.querySelector('[data-product-form]');
    const idInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addText = section.querySelector('[data-add-to-cart-text]');
    const moneyFormat = window.Shopify?.money_format || '${{amount}}';
    if (addText && !addText.dataset.defaultText) addText.dataset.defaultText = addText.textContent;

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    };

    const selectedOptions = () => Array.from(section.querySelectorAll('.variant-picker input:checked')).map((input) => input.value);
    const updateVariant = () => {
      if (!variants.length) return;
      const options = selectedOptions();
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === options[index]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? addText.dataset.defaultText : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    form?.querySelectorAll('.variant-picker input').forEach((input) => input.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('.product-media').forEach((wrapper) => {
    const track = wrapper.querySelector('[data-product-media-track]');
    const slides = Array.from(wrapper.querySelectorAll('[data-product-media-slide]'));
    const thumbs = Array.from(wrapper.querySelectorAll('.product-media__thumb'));
    if (!track || !slides.length) return;

    const setActiveThumb = (index) => {
      thumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      thumbs[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        const slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActiveThumb(index);
      });
    });

    let mediaScrollTimer = null;
    track.addEventListener('scroll', () => {
      window.clearTimeout(mediaScrollTimer);
      mediaScrollTimer = window.setTimeout(() => {
        const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setActiveThumb(Math.max(0, Math.min(index, slides.length - 1)));
      }, 80);
    }, { passive: true });
  });

  document.querySelectorAll('[data-coa-search]').forEach((input) => {
    const list = input.closest('.coa-library')?.querySelector('[data-coa-list]');
    if (!list) return;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      list.querySelectorAll('[data-coa-card]').forEach((card) => {
        card.hidden = query && !card.textContent.toLowerCase().includes(query);
      });
    });
  });

  document.querySelectorAll('[data-catalog]').forEach((catalog) => {
    const search = catalog.querySelector('[data-catalog-search]');
    const price = catalog.querySelector('[data-catalog-price]');
    const priceValue = catalog.querySelector('[data-catalog-price-value]');
    const items = Array.from(catalog.querySelectorAll('[data-catalog-item]'));
    const empty = catalog.querySelector('[data-catalog-empty]');
    const count = document.querySelector('[data-catalog-count]');
    const state = { category: 'all', tag: 'all' };

    const apply = () => {
      const query = (search?.value || '').trim().toLowerCase();
      const maxPrice = Number(price?.value || Infinity);
      let visible = 0;

      items.forEach((item) => {
        const title = (item.dataset.title || '').toLowerCase();
        const category = item.dataset.category || '';
        const tags = item.dataset.tags || '';
        const itemPrice = Number(item.dataset.price || 0);
        const matchesQuery = !query || title.includes(query);
        const matchesCategory = state.category === 'all' || category === state.category;
        const matchesTag = state.tag === 'all' || tags.split(',').map((tag) => tag.trim()).includes(state.tag);
        const matchesPrice = itemPrice <= maxPrice;
        const show = matchesQuery && matchesCategory && matchesTag && matchesPrice;
        item.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = `Showing ${visible} result${visible === 1 ? '' : 's'}`;
      if (priceValue && price) priceValue.textContent = price.value;
    };

    catalog.querySelectorAll('[data-catalog-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const type = button.dataset.catalogFilter;
        state[type] = button.dataset.value || 'all';
        catalog.querySelectorAll(`[data-catalog-filter="${type}"]`).forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        apply();
      });
    });

    search?.addEventListener('input', apply);
    price?.addEventListener('input', apply);
    catalog.querySelectorAll('[data-catalog-apply]').forEach((button) => button.addEventListener('click', apply));
    catalog.querySelectorAll('[data-catalog-reset]').forEach((button) => {
      button.addEventListener('click', () => {
        state.category = 'all';
        state.tag = 'all';
        if (search) search.value = '';
        if (price) price.value = price.max;
        catalog.querySelectorAll('[data-catalog-filter]').forEach((item) => item.classList.remove('active'));
        catalog.querySelectorAll('[data-catalog-filter][data-value="all"]').forEach((item) => item.classList.add('active'));
        apply();
      });
    });
    apply();
  });

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
